import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Button,
  Paper,
  useTheme,
  alpha,
  Container,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LockIcon from '@mui/icons-material/Lock';
import PricingCard from './PricingCard';

const PricingSection = ({
  loading,
  handlePlanSelect,
  handleBack,
}) => {
  const theme = useTheme();
  const [selectedPlan, setSelectedPlan] = useState(null);

  const handlePlanSelection = (plan) => {
    setSelectedPlan(plan);
    // Store in local storage
    const planData = {
      plan: plan,
      timestamp: new Date().toISOString(),
      price: plan === "Laser Targeted AI Sourced Lead" ? "25" : 
             plan === "Final Expense & ACA Live Transfer" ? "40" : "1997"
    };
    localStorage.setItem('leadPlanSelection', JSON.stringify(planData));
    handlePlanSelect(plan);
  };

  return (
    <Box>
      <Box sx={{ mb: 6 }}>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          sx={{ 
              mb: 4,
              color: "#64B5F6",
            '&:hover': {
              backgroundColor: alpha(theme.palette.primary.main, 0.1),
            }
          }}
        >
          Back to Qualification Form
        </Button>
        
        <Typography 
          variant="h4" 
          gutterBottom 
          sx={{ 
            fontWeight: 700, 
            mb: 2,
            textAlign: "center",
            background: "linear-gradient(45deg, #fff, #64B5F6)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            textShadow: "0 2px 10px rgba(100, 181, 246, 0.3)",
          }}
        >
          Select Your Lead Plan
        </Typography>
        
        <Typography 
          variant="h6" 
          sx={{ 
            textAlign: "center",
            color: alpha(theme.palette.text.secondary, 0.9),
            mb: 6,
            maxWidth: 800,
            mx: 'auto',
            px: 2,
          }}
        >
          Choose the plan that best fits your needs and start generating high-quality leads today
        </Typography>
      </Box>
      
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="center">
          {/* Social Media Lead Plan */}
          <Grid item xs={12} md={4}>
            <PricingCard
              title="Insurance Producer Package"
              price="25"
              features={[
                
                "Social Media Advertisment",
                "AI Driven Leads Machine",
                "Includes* access to AI Driven Live Transfers",
                "Delivered to via CRM/Email/SMS",
                "(Premium insurance leads are available for $20 to $300 per Lead, including contact and intent data)"
                
              ]}
              buttonText={selectedPlan === "Insurance Producer Package" && loading ? "Processing..." : "Get Started"}
              isPopular={false}
              onClick={() => handlePlanSelection("Insurance Producer Package")}
              disabled={selectedPlan === "Insurance Producer Package" && loading}
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            />
          </Grid>

          {/* Final Expense & ACA Live Transfer Plan */}
          <Grid item xs={12} md={4}>
            <PricingCard
              title="Live Transfer Program"
              price="40"
              features={[
                
                "The highest Intent on the Market",
                "All States Available",
                "FEX,ACA,TERM",
                "Closing rate as high as 75%",
                "Limited Availability*"
              ]}
              buttonText={selectedPlan === "Live Transfer Program" && loading ? "Processing..." : "Get Started"}
              isPopular={true}
              onClick={() => handlePlanSelection("Live Transfer Program")}
              disabled={selectedPlan === "Live Transfer Program" && loading}
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                transform: 'scale(1.05)',
                zIndex: 1,
                [theme.breakpoints.down('md')]: {
                  transform: 'scale(1)',
                }
              }}
            />
          </Grid>

          {/* Done-For-You Pro Plan */}
          {/* <Grid item xs={12} md={4}>
            <PricingCard
              title="Done-For-You Pro"
              price="1997"
              features={[
                "AI-Powered Lead Tsunami (Limited Spots)",
                "AI-Optimized Facebook Ads",
                "Instant CRM Sync + SMS Alerts",
                "24/7 Priority Support",
                "FREE AI Lead Gen Vault ($497 Value)",
                "5x AI-generated UGC video scripts",
                "Psychic Targeting playbook",
                "AI Compliance Auditor",
                "FREE AI Ad Templates ($297 Value)"
              ]}
              buttonText={selectedPlan === "Done-For-You Pro" && loading ? "Processing..." : "Get Started"}
              isPopular={false}
              onClick={() => handlePlanSelection("Done-For-You Pro")}
              disabled={selectedPlan === "Done-For-You Pro" && loading}
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            />
          </Grid> */}

        </Grid>

        <Box sx={{ mt: 16, textAlign: "center" }}>
          <Paper 
            elevation={0}
            sx={{ 
              display: "inline-flex",
              alignItems: "center",
              gap: 1.5,
              px: 4,
              py: 2,
              borderRadius: 3,
              background: alpha(theme.palette.primary.main, 0.1),
              border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              backdropFilter: 'blur(10px)',
              maxWidth: '100%',
              [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
                textAlign: 'center',
                px: 3,
                py: 2,
              }
            }}
          >
            <LockIcon sx={{ 
              color: theme.palette.primary.main, 
              fontSize: 24,
              [theme.breakpoints.down('sm')]: {
                mb: 1,
              }
            }} />
            <Typography 
              variant="body1" 
              sx={{ 
                color: alpha(theme.palette.text.secondary, 0.9),
                fontWeight: 500,
                [theme.breakpoints.down('sm')]: {
                  fontSize: '0.9rem',
                }
              }}
            >
              All plans include: TCPA/FCC compliance, real-time delivery, and lead replacement for invalid contacts.
            </Typography>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
};

export default PricingSection; 